import { useTranslation } from "react-i18next";
import { BedDouble, UtensilsCrossed } from "lucide-react";
import { HOLIDAY_IMAGES } from "../../data/holidays";
import { Chapter, Reveal } from "./shared";

export default function HolidayStay() {
  const { t } = useTranslation();
  const S = HOLIDAY_IMAGES.stay;
  const alt = (k) => t(`holidays.stay.alts.${k}`);
  return (
    <section className="bg-bone py-24 lg:py-40" data-testid="holidays-stay">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-end">
          <div className="lg:col-span-6">
            <Chapter number={t("holidays.stay.chapter")} label={t("holidays.stay.eyebrow")} />
            <Reveal delay={0.1}>
              <h2 className="font-display text-5xl sm:text-6xl lg:text-8xl text-forest leading-[0.98] mt-8 uppercase tracking-tight">
                Stay in the<br /><span className="italic normal-case pl-[8%]">Apuseni</span>
              </h2>
            </Reveal>
          </div>
          <Reveal delay={0.2} className="lg:col-span-6 space-y-5 text-base md:text-lg text-muted-foreground leading-relaxed">
            <p className="text-forest">{t("holidays.stay.p1")}</p>
            <p>{t("holidays.stay.p2")}</p>
            <div className="flex flex-wrap gap-3 pt-2">
              <Pill icon={<BedDouble className="w-4 h-4" />} label={t("holidays.stay.p3")} />
            </div>
          </Reveal>
        </div>

        <div className="mt-16 lg:mt-24 grid grid-cols-6 gap-3 md:gap-5">
          <Photo className="col-span-6 md:col-span-4 aspect-[16/9]" src={S.front} alt={alt("front")} />
          <Photo className="col-span-3 md:col-span-2 aspect-[4/5] md:aspect-auto" src={S.dining} alt={alt("dining")} />
          <Photo className="col-span-3 md:col-span-2 aspect-[4/3]" src={S.room} alt={alt("room")} delay={0.05} />
          <Photo className="col-span-6 md:col-span-2 aspect-[16/9] md:aspect-[4/3]" src={S.terrace} alt={alt("terrace")} delay={0.1} />
          <Photo className="col-span-6 md:col-span-2 aspect-[16/9] md:aspect-[4/3]" src={S.handlebar} alt={alt("handlebar")} delay={0.15} />
          <Photo className="col-span-3 aspect-[16/10]" src={S.lawn} alt={alt("lawn")} />
          <Photo className="col-span-3 aspect-[16/10]" src={S.garden} alt={alt("garden")} delay={0.1} />
        </div>

        <Reveal className="mt-10 flex items-center gap-3 text-xs uppercase tracking-wider-3 text-moss">
          <UtensilsCrossed className="w-4 h-4 text-terracotta" />
          {t("holidays.stay.p3")}
        </Reveal>
      </div>
    </section>
  );
}

function Pill({ icon, label }) {
  return (
    <span className="inline-flex items-center gap-2 border border-forest text-forest px-4 py-2 text-xs uppercase tracking-wider-2">
      {icon} {label}
    </span>
  );
}

function Photo({ src, alt, className = "", delay = 0 }) {
  return (
    <Reveal className={`relative overflow-hidden bg-stoneWarm group ${className}`} y={30} delay={delay}>
      <img src={src} alt={alt} loading="lazy" decoding="async" className="absolute inset-0 w-full h-full object-cover cine-img" />
    </Reveal>
  );
}
